import React, { ReactNode } from 'react'
import { AccessoryPositions } from '../Cell'

interface AccordionContexProps {
  id: string
  expanded: boolean
  onHeaderClick: () => void
  disabled: boolean
  verticalAlignLabel: boolean
  accessoryPosition?: AccessoryPositions
  testNameSpace: string
  animated: boolean
  caret?: ReactNode
}

export const AccordionContext = React.createContext<AccordionContexProps>({
  id: '',
  expanded: false,
  onHeaderClick: () => {},
  disabled: false,
  verticalAlignLabel: false,
  testNameSpace: '',
  animated: false,
})
